<template>
	<div class="hstack gap-1 scrollable-x mx-n4 px-4" v-if="loading">
		<button type="button" class="btn btn-sm rounded-pill ps-3 px-2 placeholder col-4 col-sm-3"></button>
		<button type="button" class="btn btn-sm rounded-pill ps-3 px-2 placeholder col-3 col-sm-2"></button>
	</div>
	<div class="hstack gap-1 flex-sm-wrap scrollable-x mx-n4 px-4" v-else>
		<CustomerCommonStatusOptionButton v-for="(count, index) in statuses" v-bind:key="index" :count="count" :selected="modelValue == count.status" @select="select" />
	</div>
</template>

<script>
	import { ref, onMounted } from 'vue';
	import router from '@/router';
	import composableForm from '@/composables/form';
	import CustomerRepository from '@/repositories/modules/Customer';

	export default {
		emits: ['update:modelValue'],
		props: {
			modelValue: String,
			filters: Object,
			onSelect: {
				type: String,
				default: 'select'
			}
		},
		setup(props, { emit }) {
			const { loading } = composableForm();
			const statuses = ref([]);

			const getResults = async () => {
				loading.value = true;

				await CustomerRepository.counts({ company_id: props.filters?.company_id }).then((response) => {
					statuses.value = response.data;
				}).catch((e) => catchError(e, true));

				loading.value = false;
			}

			const select = (data) => {
				switch(props.onSelect) {
					case 'select':
						if(props.modelValue == data) emit('update:modelValue', null);
						else emit('update:modelValue', data);
						break;
					case 'redirect':
						router.push({ name: 'customer.index', query: { status: data }});
						break;
				}
			};

			onMounted(getResults);

			return { loading, statuses, getResults, select };
		}
	}
</script>